import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-tickets-ticket-preview-dialog',
  templateUrl: './tickets-ticket-preview-dialog.component.html',
  styleUrls: ['./tickets-ticket-preview-dialog.component.scss']
})
export class TicketsTicketPreviewDialogComponent implements OnInit {

  @ViewChild('e', { static: true }) e: ElementRef;

  constructor(public dialogRef: MatDialogRef<TicketsTicketPreviewDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() { }

  public getHtmlHeight() {
    if (this.e.nativeElement.contentDocument.children[0]) {
      return this.e.nativeElement.contentDocument.children[0].scrollHeight;
    }
  }

}
